import { csrftoken } from "../../shared/utils.js";
import { fetchError, getJsonOrThrow } from "../../shared/api.js";
import api from "/traveller/api";
const VISITED_BUSINESS_BASE_URL = "/traveller/api/visited/business/";
/*
 * Returns a list of highlights for a traveller for a country.
 *
 * travellerCode (String) - a unique code identifying a TravellerProfile
 * countryCode (String) - two-character ISO code representing a country
 */
function getHighlights(travellerCode, countryCode) {
  return fetch(
    `${VISITED_BUSINESS_BASE_URL}?traveller__code=${travellerCode}&business__country=${countryCode}`
  )
    .catch(fetchError)
    .then(getJsonOrThrow);
}

function getAllHighlights(travellerCode) {
  return fetch(`${VISITED_BUSINESS_BASE_URL}?traveller__code=${travellerCode}`)
    .catch(fetchError)
    .then(getJsonOrThrow);
}
/*
 * Returns necessary data to construct a 'preview' of a business profile page.
 *
 * businessCode (String) - the five-character code identifying a business
 * travellerCode (String) - traveller code to retrieve highlights they own
 */
function getFullHighlight(businessCode, travellerCode = "") {
  return fetch(
    `/traveller/api/profile-preview/${businessCode}${
      travellerCode ? "/" + travellerCode + "/" : ""
    }`
  )
    .catch(fetchError)
    .then(getJsonOrThrow);
}
/*
 * Returns a list of areas in a given country.
 *
 * countryCode (String) - two-character ISO code representing a country
 */
async function getAreas(countryCode) {
  // do *not* filter by `category`
  let resp = await api.travellerAreasInCountryList("", countryCode);
  return resp.data;
}

async function createHighlight(data) {
  let resp = await api.travellerApiVisitedBusinessCreate(data);
  return resp.data;
}

function editHighlight(highlightUuid, newHighlightData) {
  return fetch(`${VISITED_BUSINESS_BASE_URL}${highlightUuid}/`, {
    method: "PUT",
    headers: {
      "X-CSRFToken": csrftoken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(newHighlightData),
  })
    .catch(fetchError)
    .then(getJsonOrThrow);
}
export {
  getAreas,
  getHighlights,
  getAllHighlights,
  getFullHighlight,
  createHighlight,
  editHighlight,
};
//# sourceMappingURL=api.js.map
